/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Password_HintInputs */

const cs_share_password_hint = /** @type {(inputs: Share_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento odkaz je chráněný heslem.`)
};

const en_share_password_hint = /** @type {(inputs: Share_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link is password protected.`)
};

/**
* | output |
* | --- |
* | "This link is password protected." |
*
* @param {Share_Password_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const share_password_hint = /** @type {((inputs?: Share_Password_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Password_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_password_hint(inputs)
	return cs_share_password_hint(inputs)
});